
// Remove role="main" from <style> tags
// Specifically Swatch King Style tag <style app="vsk">
const observer = new MutationObserver(() => {
  document.querySelectorAll('style[role="main"]').forEach((el) => {
    el.removeAttribute('role');
  });
    document.querySelectorAll('script[role="custom-script"]').forEach((el) => {
    el.removeAttribute('role');
  });
});

observer.observe(document.documentElement, { childList: true, subtree: true });



// ============================================================
// Global Slick Slider Accessibility Fixes
// ============================================================
// Slick generates several invalid/problematic ARIA attributes:
// - aria-describedby references duplicate IDs across multiple sliders
// - tabindex="0" on non-interactive <div> and <img> slides
// - role="tabpanel" is invalid on <a> elements
// - Nav carousel thumbnails need role="button" + aria-label
// ============================================================

// Fix slides as each slider initializes
$(document).on('init reInit', '.slick-slider', function() {
  $(this).find('.slick-slide').each(function() {

    // Remove aria-describedby — references duplicate IDs across multiple slider instances
    $(this).removeAttr('aria-describedby');

    if ($(this).is('a')) {
      // Remove role="tabpanel" — not a valid role for <a> elements
      $(this).removeAttr('role');
    } else if (!$(this).hasClass('nav-carousel__image--wrapper')) {
      // Remove tabindex from non-interactive <div> and <img> slides
      // Nav carousel thumbnails are excluded as they are intentionally interactive
      $(this).removeAttr('tabindex');
    }
  });

  // Nav carousel thumbnails need role="button" + aria-label
  // since they are interactive but are <div> elements with no implicit role
  $(this).find('.nav-carousel__image--wrapper.slick-slide').each(function(index) {
    var altText = $(this).find('img').attr('alt');
    var label = altText ? altText : 'Product image ' + (index + 1);
    $(this).attr('role', 'button').attr('aria-label', label);
  });
});

// Catch any sliders already initialized before this script runs
$(window).on('load', function() {
  $('.slick-slide').each(function() {

    // Remove aria-describedby — references duplicate IDs across multiple slider instances
    $(this).removeAttr('aria-describedby');

    if ($(this).is('a')) {
      // Remove role="tabpanel" — not a valid role for <a> elements
      $(this).removeAttr('role');
    } else if (!$(this).hasClass('nav-carousel__image--wrapper')) {
      // Remove tabindex from non-interactive <div> and <img> slides
      // Nav carousel thumbnails are excluded as they are intentionally interactive
      $(this).removeAttr('tabindex');
    }
  });

  // Nav carousel thumbnails need role="button" + aria-label
  // since they are interactive but are <div> elements with no implicit role
  $('.nav-carousel__image--wrapper.slick-slide').each(function(index) {
    var altText = $(this).find('img').attr('alt');
    var label = altText ? altText : 'Product image ' + (index + 1);
    $(this).attr('role', 'button').attr('aria-label', label);
  });
});


// Height Attribute from HubSpot form iFrames
$(window).on('load', function() {
  document.querySelectorAll('.hs-form-iframe').forEach(function(iframe) {
    iframe.removeAttribute('height');
  });
});

// Adds title to Shopify WebPixel <iframe>
$(window).on('load', function() {
  $('#web-pixels-manager-sandbox-container iframe').each(function(index) {
    $(this).attr('title', 'Shopify Web Pixel ' + (index + 1));
  });
});